import {
  Dispatch,
  PropsWithChildren,
  SetStateAction,
  createContext,
  createElement,
  useContext,
  useMemo,
  useState,
} from 'react';

type SessionContextType = {
  session: string;
  setSession: Dispatch<SetStateAction<string>>;
};

const SessionContext = createContext<SessionContextType>({
  session: '',
  setSession: (_1: string | ((_2: string) => string)) => {},
});

export function useSessionContext() {
  return useContext(SessionContext);
}

export const SessionContextProvider = (props: PropsWithChildren) => {
  const [session, setSession] = useState('');
  const value = useMemo(() => ({ session, setSession }), [session]);
  return createElement(SessionContext.Provider, { value }, props.children);
};
